module.exports = __webpack_public_path__ + "img/Active-Managers.7567b955.png";